import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import Column from "./Column";

const Bar = (props) => {
    const { loading, error, options: customOptions, setChart } = props;
    const staticOptions = {
        chart: {
            type: "bar"
        }
    };
    const options = _.merge({}, staticOptions, customOptions);

    return (
        <Column loading={loading} error={error} options={options} dataCy="bar-chart" setChart={setChart} />
    );
};

Bar.propTypes = {
    loading: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
    options: PropTypes.object.isRequired,
    setChart: PropTypes.func
};

Bar.defaultProps = {
    loading: false,
    error: false
};

export default Bar;
